import {
    checkStatusValidation,
    createBookRemuneration,
} from "@/api/s3BookRemunerations";
import WebSocket from "@/utils/baseWebSocket";

export default {
    state: () => ({
        webSocketRemunerations: {
            responseMessage: {
                complete_transaction: false,
                errors: "",
            },
        },
        webSocketOtherRemunerations: {
            responseMessage: {
                complete_transaction: false,
                errors: "",
            },
        },
    }),
    mutations: {
        SET_WEBSOCKET: (state, payload) => {
            if (payload.responseMessage.kind_file == "remuneration") {
                state.webSocketRemunerations = payload;
            } else if(payload.responseMessage.kind_file == "other_obligations"){
                state.webSocketOtherRemunerations = payload;
            }
        },
        SET_TRANSACTION: (state, payload) => {
            if (payload.kind_file == "remuneration"){
                state.webSocketRemunerations.responseMessage.complete_transaction =
                    payload.complete_transaction;
            } else if(payload.kind_file == "other_obligations"){
                state.webSocketOtherRemunerations.responseMessage.complete_transaction =
                    payload.complete_transaction;
            }
        },
        SET_STATUS_FOR_FILES: (state, newStatus) => {
            if(state.webSocketRemunerations.responseMessage.status == 'SUBIDO_EXITOSAMENTE') {
                state.webSocketRemunerations.responseMessage.complete_transaction = newStatus
            }
            if(state.webSocketOtherRemunerations.responseMessage.status == 'SUBIDO_EXITOSAMENTE') {
                state.webSocketOtherRemunerations.responseMessage.complete_transaction = newStatus
            }
        },
    },
    actions: {
        callCreateBookRemuneration({ commit, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                let kind_file = payload.get("kind_file")
                commit("SET_STATUS_FOR_FILES", false);
                createBookRemuneration(payload)
                    .then((response) => {
                        const initialPayload = {
                            responseMessage: {
                                complete_transaction: false,
                                ...response.data,
                            },
                        };
                        commit("SET_WEBSOCKET", initialPayload);
                        dispatch("startWebSocket", kind_file);
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        startWebSocket({ commit }, payload) {
            let webSocket = WebSocket;
            webSocket.connect(checkStatusValidation, payload);
            webSocket.responseMessage.kind_file = payload;
            commit("SET_WEBSOCKET", webSocket);
        },
    },
    getters: {},
    namespaced: true,
};
